// extracted by mini-css-extract-plugin
export default {"secondary":"SecondaryButton_secondary__rMOQq","white":"SecondaryButton_white__4f5Z7"};